( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .factory( 'ShipmentMinDTO', ShipmentMinDTO );

    ShipmentMinDTO.$inject = [ '$resource', 'DateUtils' ];

    function ShipmentMinDTO( $resource, DateUtils ) {
        var resourceUrl = "api/shipmentMinDTO/:id";

        return $resource( resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.shipmentDate = DateUtils.convertLocalDateFromServer(data.shipmentDate);
                    }
                    return data;
                }
            }
        });
    }
})();
